import { render, staticRenderFns } from "./NbCardCreateOverpack.vue?vue&type=template&id=39db171a&scoped=true&"
import script from "./NbCardCreateOverpack.vue?vue&type=script&lang=js&"
export * from "./NbCardCreateOverpack.vue?vue&type=script&lang=js&"
import style0 from "./NbCardCreateOverpack.vue?vue&type=style&index=0&id=39db171a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db171a",
  null
  
)

export default component.exports